import { isCryptoKey } from './webcrypto.js';
export default (function (key) {
  if (isCryptoKey(key)) {
    return true;
  }
  return (key === null || key === void 0 ? void 0 : key[Symbol.toStringTag]) === 'KeyObject';
});
export var types = ['CryptoKey'];